// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__bq2Rz","label":"Labeled_label__36fu9","divider":"Labeled_divider__1495F"};